import React from 'react'
import { FormattedMessage } from 'react-intl'

import AdminActionButton from '../admin-action/AdminActionButton'
import { AdminActionEnum } from '../admin-action/utils/admin-action-data'
import PingPongButton from '../../buttons-by-step/PingPongButton'
import { PingPongButtonTypeEnum } from '../../utils/ping-pong-button-type.enum.ts'
import { openHubSpotChat } from '../../../../../../utils'
import { IProposalInteractionsProps } from '../../../Proposal'

interface IBalancePaidFooterProps {
  adminActions: IProposalInteractionsProps['adminActions']
  clientProposalId: string
}

const BalancePaidFooter = ({
  adminActions,
  clientProposalId,
}: IBalancePaidFooterProps) => {
  const adminConfirmedPostBalanceAdjustments =
    adminActions?.adminConfirmedPostBalanceAdjustments

  return (
    <div className='flex w-full flex-col gap-3 py-5'>
      <PingPongButton
        dataTestId='balance-paid-button'
        type={PingPongButtonTypeEnum.PAYMENT_DONE}
        label={
          <FormattedMessage
            id='ui.AdminCanConfirmPostBalanceAdjustmentsFooter.balancePaid'
            defaultMessage='Solde réglé'
          />
        }
      />
      <PingPongButton
        label={
          <FormattedMessage
            id='ui.ClientButtonsStepSix.contactNabooAdvisor'
            defaultMessage='Contacter votre conseiller Naboo'
          />
        }
        type={PingPongButtonTypeEnum.CONTACT_ADMIN}
        onClick={openHubSpotChat}
        dataTestId='contact-admin-button'
      />
      {adminConfirmedPostBalanceAdjustments && (
        <AdminActionButton
          adminAction={AdminActionEnum.CONFIRM_POST_BALANCE_ADJUSTMENTS}
          onClickConfirm={() =>
            adminConfirmedPostBalanceAdjustments.callback({ clientProposalId })
          }
          isLoading={adminConfirmedPostBalanceAdjustments.isLoading}
        />
      )}
    </div>
  )
}

export default BalancePaidFooter
